import { render, staticRenderFns } from "./SendBulkEmail.component.vue?vue&type=template&id=15c00dee&scoped=true"
import script from "./SendBulkEmail.component.vue?vue&type=script&lang=js"
export * from "./SendBulkEmail.component.vue?vue&type=script&lang=js"
import style0 from "./SendBulkEmail.component.vue?vue&type=style&index=0&id=15c00dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c00dee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VProgressCircular,VTextField})
